import type { LightInvoiceUsageLineItem } from '@weft/api-definition';
import type { Currency } from '@weft/types';
import { formatNumber } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import cn from 'classnames';
import React from 'react';
import { getPerUnitProductVariantPrice } from '../light-invoice-utils/get-per-unit-product-variant-price';
import { LightInvoiceProductItem } from './LightInvoiceProductItem';
import { LightInvoiceProductSection } from './LightInvoiceProductSection';
import { LightInvoiceTiersUsageCharges } from './LightInvoiceTiersUsageCharges';

type LightInvoiceUsageChargesProps = {
  usageLineItems: LightInvoiceUsageLineItem[]
  isPdf?: boolean;
  currency: Currency;
};

export const LightInvoiceUsageCharges:React.FC<LightInvoiceUsageChargesProps> = ({
  usageLineItems,
  isPdf,
  currency,
}) => {
  return (
    <div className={cn(!isPdf && 'space-y-3')}>
      {usageLineItems.map((lineItem, index) => {
        const { price, perUnitProductVariants, productTitle, tiersProductVariants, tiersUsageMap, productDescription } = lineItem;
        const productVariantsCount = perUnitProductVariants.length + tiersProductVariants.length;

        return (
          <LightInvoiceProductSection
            key={index}
            name={productTitle}
            description={productDescription}
            isPdf={isPdf}
            price={`${getCurrencySymbol(currency)}${formatNumber(price)}`}
          >
            <div className="flex flex-col gap-3">
              {perUnitProductVariants.map((productVariant) => {
                const perUnitVariantPrice = getPerUnitProductVariantPrice(productVariant, tiersUsageMap);

                return (
                  <LightInvoiceProductItem
                    key={productVariant.id}
                    price={perUnitVariantPrice}
                    units={tiersUsageMap[productVariant.id][0].periodUnits}
                    currency={currency}
                  />
                );
              })}
              {tiersProductVariants.map((productVariant) => {
                return (
                  <React.Fragment key={productVariant.id}>
                    {productVariantsCount > 1 && (
                      <div className="pb-2 text-base font-medium text-black">{productVariant.name}</div>
                    )}
                    <LightInvoiceTiersUsageCharges
                      pricingConfiguration={productVariant.pricing.priceConfiguration}
                      productVariantId={productVariant.id}
                      tierUsageMap={tiersUsageMap}
                      currency={currency}
                    />
                  </React.Fragment>
                );
              })}
            </div>
          </LightInvoiceProductSection>
        );
      })}
    </div>
  );
};